export enum NotificationPermissions {
	default = 'default',
	granted = 'granted',
	denied = 'denied',
}
